import { render, staticRenderFns } from "./AIChatView.vue?vue&type=template&id=1f5c2c4a"
import script from "./AIChatView.vue?vue&type=script&lang=js"
export * from "./AIChatView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports